
    import './styles.scoped.css';
    export default {
  "empty-appear": "awsui_empty-appear_n4qlp_1rsbk_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_n4qlp_1rsbk_1",
  "root": "awsui_root_n4qlp_1rsbk_35",
  "empty": "awsui_empty_n4qlp_1rsbk_13",
  "row": "awsui_row_n4qlp_1rsbk_81",
  "divider": "awsui_divider_n4qlp_1rsbk_85",
  "row-control": "awsui_row-control_n4qlp_1rsbk_90",
  "field": "awsui_field_n4qlp_1rsbk_94",
  "additional-info": "awsui_additional-info_n4qlp_1rsbk_98",
  "add-row": "awsui_add-row_n4qlp_1rsbk_145",
  "add-button": "awsui_add-button_n4qlp_1rsbk_149",
  "remove-button-container": "awsui_remove-button-container_n4qlp_1rsbk_153",
  "remove-button-field-padding": "awsui_remove-button-field-padding_n4qlp_1rsbk_157",
  "remove-button-own-row": "awsui_remove-button-own-row_n4qlp_1rsbk_161",
  "remove-button": "awsui_remove-button_n4qlp_1rsbk_153"
};
  